<template>
  <div class="page">
    <router-view></router-view>
    <div class="footer">
      <button @click="$router.push({name:'category'})">シミュレータ画面にもどる</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'how',
  }
</script>

<style scoped>
  .page{
    padding: 10px 10px 60px 10px;
  }
  .footer {
    text-align: center;
  }
</style>
